module.exports = __webpack_public_path__ + "static/media/EventPhoto3.78bb00cb.jpg";